module.exports = require('./$.global');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.path.js
// module id = 598
// module chunks = 226573449209678